let user: ALLUser;

export function setCurrentUser(u: ALLUser) {
    user = u;
}

export function getCurrentUser() {
  return user;
}
